import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  defaultUrlMatcher,
  UrlSegmentGroup
} from '@angular/router';
import { map, switchMap } from 'rxjs';
import { CardViewService } from './card-view.service';

export const resolveDynamicCardViewConfig = (route: ActivatedRouteSnapshot) => {
  const cardViewService = inject(CardViewService);
  return cardViewService.getViews('card').pipe(
    switchMap((views) => {
      const found = views.find((view) => {
        const segmentGroup = new UrlSegmentGroup(route.url, {});
        return !!defaultUrlMatcher(route.url, segmentGroup, {
          path: view.Path
        });
      });
      if (!found) {
        throw new Error('Dynamic card config not found for url: ' + route.url);
      }
      return cardViewService.getView(found.Path, 'card').pipe(
        map((view) => {
          if (!view) {
            throw new Error(
              'Dynamic card config not found for url: ' + route.url
            );
          }
          return view;
        })
      );
    })
  );
};
